<template>
  <div class="pagination-wrap">
    <el-pagination
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 30, 50, 100]"
      :page-size="pageSize"
      :layout="layout"
      :total="list.length"
    ></el-pagination>
  </div>
</template>

<script>
export default {
  name: 'LocalPagination',
  props: {
    list: {
      type: Array,
      default: () => []
    },
    layout: {
      type: String,
      default: 'total, sizes, prev, pager, next, jumper',
    },
    value: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      currentPage: 1,
      pageSize: 10,
    }
  },
  computed: {
    tableData() {
      const start = (this.currentPage - 1) * this.pageSize
      const end = start + this.pageSize
      return this.list.slice(start, end)
    }
  },
  watch: {
    tableData: {
      immediate: true,
      handler(newVal) {
        this.$emit('input', newVal)
      }
    }
  },
  methods: {
    handleSizeChange(val) {
      this.pageSize = val
      this.$emit('sizeChange', val)
      this.handleCurrentChange(1)
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.$emit('currentChange', val)
    },
  },
}
</script>

<style scoped lang="less">
.pagination-wrap {
  text-align: right;
  padding: 8px 12px 12px;
}
</style>
